// Shared presentation helpers for the blog pages (listing + detail).
// Shapes live GET /v1/blog-posts records into the props the blog UI renders.

export const stripHtml = (html) =>
  String(html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&mdash;/g, '—')
    .replace(/&rsquo;|&#39;/g, "'")
    .replace(/&quot;|&ldquo;|&rdquo;/g, '"')
    .replace(/\s+/g, ' ')
    .trim()

export const formatDate = (iso) => {
  if (!iso) return ''
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

/** ~200 wpm reading speed on the plain-text body. */
export const readTime = (text) => {
  const words = String(text).split(' ').filter(Boolean).length
  return `${Math.max(1, Math.round(words / 200))} min read`
}

export const excerptFrom = (post, plainContent) => {
  const own = (post.excerpt ?? '').trim()
  if (own) return own
  if (plainContent.length <= 140) return plainContent
  const cut = plainContent.slice(0, 140)
  return `${cut.slice(0, cut.lastIndexOf(' '))}…`
}

/** The name an article is published under. */
export const authorName = (author) => {
  const full = [author?.first_name, author?.middle_name, author?.last_name].filter(Boolean).join(' ').trim()
  return author?.display_name || full || 'Astrologer Raju'
}

/**
 * The line under the byline. Astrologers write here too now, so this is their
 * own credential (their profile's short intro, or their experience) rather than
 * the one title the page used to print for every article. null means the UI
 * omits the line — better than inventing a credential for a house post.
 */
export const authorCredential = (author) => {
  if (!author?.is_astrologer) return null
  const intro = (author.headline ?? '').trim()
  if (intro) return intro
  return author.experience ? `${author.experience}+ years of Vedic practice` : 'Vedic Astrologer'
}

/** Shape a live API blog post into the props BlogCard / the blog pages render. */
export function decoratePost(post) {
  const plain = stripHtml(post.content)
  return {
    id: post.id,
    slug: post.slug,
    img: post.featured_image_url,
    title: post.title,
    excerpt: excerptFrom(post, plain),
    badge: post.category?.name ?? 'Insights',
    categorySlug: post.category?.slug ?? null,
    author: authorName(post.author),
    authorCredential: authorCredential(post.author),
    authorPhoto: post.author?.photo_url ?? null,
    date: formatDate(post.published_at),
    publishedAt: post.published_at,
    readTime: readTime(plain),
    views: typeof post.views === 'number' ? post.views : null,
  }
}
